import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})

export class BreadcrumbComponent implements OnInit {

  @Input() problemNo: string;
  @Input() currentPage: string;

  constructor() { }

  ngOnInit() {

  }
}
